import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import * as services from 'modules/conference/services/createConversation';
import { PROVIDER, CUSTOMER } from 'modules/common/constants/conversationParticipantsTypes';
import {
  getAppointmentCustomer,
  getAppointmentProvider,
} from 'modules/appointmentInfo/selectors/currentAppointment';

import createAction from '../';

export const CREATE_CONVERSATION = createAsyncAction(createAction('CREATE_CONVERSATION'));

export const createConversation = () => (dispatch, getState) => {
  const state = getState();
  const { appointmentId, allowedConversationTypes } = state.appointmentInfo.currentAppointment;
  const { userId } = state.user.userInfo;

  const participants = [
    {
      referenceId: getAppointmentProvider(state)
        ? getAppointmentProvider(state).userId
        : userId,
      participantType: PROVIDER,
    },
    {
      referenceId: getAppointmentCustomer(state).userId,
      participantType: CUSTOMER,
    },
  ];

  if (!participants.some(participant => participant.referenceId === userId)) {
    participants[0].referenceId = userId;
  }

  dispatch({ type: CREATE_CONVERSATION.pending });

  const apiCallParams = {
    mutation: services.CREATE_CONVERSATION,
    variables: {
      participants,
      appointmentId,
      type: allowedConversationTypes[0],
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { createConversation } }) => dispatch({
      type: CREATE_CONVERSATION.success,
      payload: { conversation: createConversation },
    }))
    .catch((err) => {
      dispatch(errorAction(CREATE_CONVERSATION.failure, err));
      throw err;
    });
};
